<script>
    /* Executable code section of the program */
    //Tools importation
    import {getLimitDocuments} from "../apis/APIS"
    import {temporalData,userRealTime} from "../apis/storage"
    import { navigate } from "svelte-routing";

    //Components importation
    import AttendeeSliderCard from "./Cards/AttendeeSliderCard.svelte";
    import EmptyAttendees from "../components/EmptySections/EmptyAttendees.svelte";

    //Auxiliary variables
    let eventAttendees =[];
    export let curretEvent
    let windowWidth = window.innerWidth;
    export let color

    (async()=>{
        eventAttendees = await getLimitDocuments("users","event",curretEvent,12)
        eventAttendees = eventAttendees.filter(element=>element.id !==$userRealTime.id)
    })();

    /* End of the section */
</script>
<!-- Section to place the HTML code -->
<body class="principalContainer">
    {#if eventAttendees === undefined || eventAttendees === null || eventAttendees.length == 0}
    <EmptyAttendees/>
    {:else}
    <div id="carouselExampleIndicators" class="carousel slide">
        <div class="carousel-indicators" style="--event-Color: {color}; background-color: {color};">
            {#each eventAttendees as attendees, index }
                {#if index === 0}
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} class="active " aria-current="true" aria-label="Slide {index+1}"></button>
                    {:else}
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} aria-label="Slide {index+1}"></button> 
                {/if}
            {/each}
        </div>
        <div class="carousel-inner carouselContainer">
            {#each eventAttendees as attendee,index}
                {#if index === 0}
                <div class="carousel-item active">
                    <AttendeeSliderCard attendeesList = {[attendee]} avatarColor={color}/>
                    <div style="height: 50px;"></div>
                  </div>
                    {:else}
                    <div class="carousel-item">
                      <AttendeeSliderCard attendeesList = {[attendee]} avatarColor={color}/>
                      <div style="height: 50px;"></div>
                    </div>
                {/if}
            {/each}
             
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" style="--event-Color: {color}; background-color: {color};" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" style="--event-Color: {color}; background-color: {color};" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>

    <div class="btnSeeMore">
        <a class="linkAttendees" href="/socialattendees/{$temporalData.id}"><button class="actionBtn addEventBtn">See More Attendees</button></a>
    </div>
  {/if}
</body>


<!-- End of the section -->
<style>
    /* Section to place the code styles */
    .principalContainer{
        background-color: white;
        width: 100%;
        height: auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
    }
    .carousel{
        width: 100%;
        display: flex;
        justify-content: center;
        color: black;
    }
    .carouselContainer{
        width: 80%;
        height: auto;
    } 
    .carousel-item{
        background-color: #f4f4f4;
        width: 100%;
        height: auto;
    }
    .carousel-control-prev-icon,.carousel-control-next-icon{
        background-color: black;
    }
    .carousel-indicators{
        background-color: rgba(0, 0, 0, 0.507);
    }
    .btnSeeMore{
        display: flex;
        justify-content: center;
        padding: 10px;
    }
    
  .linkAttendees{
    width: 100%;
    display: flex;
    justify-content: center;
    text-decoration: none;
  }
    
  .actionBtn {
    width: 90%;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

/* /////////Cellphones ///////// */
@media (max-width: 700px) {

}

    /* End of the section */
</style>
